export const GLOBAL_PLATFORM_NAME = 'Turbine Workforce';
export const GLOBAL_TURBINE_ADMIN_EMAIL = 'hello@turbineworkforce.com';
export const GLOBAL_TURBINE_ADMIN_BCC_EMAILS =
  'alan@turbineworkforce.com,josh@turbineworkforce.com';

// INTEGRATIONS
export const GLOBAL_MICROSOFT_TEAMS_CHAT_LINK_BASE =
  'https://teams.microsoft.com/l/chat/0/0?users=';
